import React from 'react';
import Button from '@mui/material/Button';
import { DialogBoxLarge } from '../../common/dialog.large';
import 'date-fns';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import { formatName } from '../../common/common';
import { CustomDatePicker } from '../../common/CustomDatePicker';
import Autocomplete from '@mui/material/Autocomplete';
import { styled } from '@mui/material/styles';
import Alert from '@mui/material/Alert';
import {CustomizedSnackbars} from '../../common/snackbars';
import parse from 'html-react-parser';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

const StyledDiv = styled('div')(({ theme }) => ({
    width: 500,
    '& > * + *': {
        marginTop: theme.spacing(3),
    },
}));


export const EventAddComponent = (props) => {
    return (
        <React.Fragment>
            <DialogBoxLarge
                Open={props.Open}
                Cancel={props.OnClose}
                ButtonName='Submit' 
                OnSubmit={props.EditId ? props.UpdateRequest : props.SubmitEventRequest}
                Title={props.Title ? 'Edit Event Request' :'New Event Request'}
                Disabled = {props.EventValidity ? false : true}
                Content={
                    <DialogAddEvent FormProps={props} />
                }
            />
            {props.SnackbarOpen &&
                <CustomizedSnackbars
                    open = {props.SnackbarOpen}
                    variant= {props.SnackbarVariant}
                    message = {props.SnackbarMsg}
                    handleClose = {props.SnackbarClose}
                />
            }
    </React.Fragment>
    )
}

const DialogAddEvent = (props) => {
    if (props.FormProps.ErrorsArray && props.FormProps.ErrorsArray.length > 0) {  
        let element = document.getElementById('errorMsg');  
        if (element) { 
            element.scrollIntoView(true);        
        }
    }
    return (
        <form className="form-fullwidth" >
             <Grid container spacing={2} >
                  <Grid item xs={12} md={12} id="errorMsg">
                    {( props.FormProps.ErrorsArray && props.FormProps.ErrorsArray.length > 0) &&
                        <>
                            {props.FormProps.ErrorsArray.map((er, i) =>
                                <><br/><span className={'error'}>{parse(er)}</span><br/><br/></>
                            )}
                        </>
                    }
                </Grid>
            <Grid item md={6} xs={12}>
                <FormControl variant = 'standard'>
                    <InputLabel htmlFor="timeoffTask" required > Request For </InputLabel>
                        <Select
                            value={(typeof props.FormProps.FormValues.timeoffTask !== 'undefined') ? props.FormProps.FormValues.timeoffTask : ""}
                            onChange={props.FormProps.HandleOnChange}
                            inputProps={{
                                name: 'timeoffTask',
                                id: 'timeoffTask',
                            }}
                            >
                            {typeof props.FormProps.TimeoffTasks!== 'undefined' && props.FormProps.TimeoffTasks.map((tt, i) =>
                                <MenuItem value={tt.id} >{tt.to_type}</MenuItem>
                            )}

                        </Select>
                         <small className='error'>{props.FormProps.ValidationErrors.timeoffTask}</small>
                    </ FormControl>
                </Grid>

                <Grid item xs={12} md={6}>
                    <FormControl>
                         <CustomDatePicker
                              id="eventDate"
                              name="eventDate"
                              selectedDate={props.FormProps.FormValues.eventDate}
                              handleDateChange={props.FormProps.HandleDateChange}
                              required={true}
                              minDate = {props.FormProps.DOJ}
                              maxDate = {props.FormProps.RelievedDate}
                              label={'Event Date'}
                          />
                          <small className='error'>{props.FormProps.ValidationErrors.eventDate}</small>
                    </ FormControl>
                    {props.FormProps.InfoMessage && props.FormProps.InfoMessage !== '' && (
                        props.FormProps.EventValidity ? (
                            <Alert severity="info">
                                {props.FormProps.InfoMessage}
                                {props.FormProps.InfoMessage.length > 60 && <br />}
                                <b> {props.FormProps.FormattedEventPeriod} </b>
                            </Alert>
                        ) : (
                            <Alert severity="error">
                                {props.FormProps.InfoMessage}
                            </Alert>
                        )
                    )}
                </Grid>
                <Grid item md={6} xs={12}>
                    <FormControl variant = 'standard'>
                        <InputLabel htmlFor="timeoffTask" >Event Type</InputLabel>
                            <Select
                            value={(typeof props.FormProps.FormValues.eventType !== 'undefined') ? props.FormProps.FormValues.eventType : ""}
                            onChange={props.FormProps.HandleOnChange}
                            inputProps={{
                                name: 'eventType',
                                id: 'eventType',
                            }}
                            >
                            <MenuItem value={0}>Select</MenuItem>
                            {typeof props.FormProps.EventTypes !== 'undefined' && props.FormProps.EventTypes.map((tt, i) =>
                                <MenuItem value={tt.id} >{tt.type}</MenuItem>
                            )}
                        </Select>
                         <small className='error'>{props.FormProps.ValidationErrors.eventType}</small>
                    </ FormControl>
                </Grid>
                {props.FormProps.FormValues.file_name &&
                <Grid item xs={12} md={6}>
                                    <FormControl>
                                        <TextField
                                            id="file_name"
                                            name="file_name"
                                            label="File Name"
                                            type="text"
                                            value={(typeof props.FormProps.FormValues.file_name !== 'undefined') ? props.FormProps.FormValues.file_name : null}
                                            disabled="true"
                                            inputProps={{ tabIndex: "10" }}
                                            variant = 'standard'
                                        />
                                    </ FormControl>
                                </Grid>
                }
                {props.FormProps.FormValues.file_name &&
                                <Grid item xs={12} md={6}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={(typeof props.FormProps.FormValues.remove_file !== 'undefined') ? props.FormProps.FormValues.remove_file : false}
                                                value={(typeof props.FormProps.FormValues.remove_file !== 'undefined') ? props.FormProps.FormValues.remove_file : null}
                                                id="remove_file"
                                                name="remove_file"
                                                onChange={props.FormProps.HandleOnChange}
                                            />
                                        }
                                        label="Remove attachment"
                                    />
                                </Grid>
                            }
            {(props.FormProps.Action == '' || (props.FormProps.Action == 'edit' && props.FormProps.FormValues.remove_file)) &&
                <Grid item xs={12} md={6}>
                      <FormControl>
                           <TextField
                                id="file"
                                name="file"
                                label={(typeof props.FormProps.file !== 'undefined' && props.FormProps.file  ) ? "Replace File" : "Upload File"}
                                InputLabelProps={{
                                        shrink: true,
                                            }}
                                type="file"
                                value={(typeof props.FormProps.file !== 'undefined') ? props.FormProps.file : null}
                                onChange={props.FormProps.HandleOnChange}
                                variant = 'standard'
                            />
                            </ FormControl>
                 </Grid>
            }
            <Grid item xs={12} md={12}>
                <ul className="list-standard list-ul-shrink">
                    <label><b>Email Recipients</b></label>
                    <li className="list-item"></li>
                    {(typeof props.FormProps.Recipients.recipients !== 'undefined' && props.FormProps.Recipients.recipients) && Object.keys(props.FormProps.Recipients.recipients).map((key) =>
                    <li className="list-item">
                        {props.FormProps.Recipients.recipients[key]['reviewer'] ?
                            <span className="value"> 
        {formatName(props.FormProps.Recipients.recipients[key]['first_name'], null, props.FormProps.Recipients.recipients[key]['last_name']) + ' (Reviewer)'} </span> :
        <span className="value">
         {formatName(props.FormProps.Recipients.recipients[key]['first_name'], null, props.FormProps.Recipients.recipients[key]['last_name'])}  </span>
        }
                  </li>
                   )}
                </ul>
          </Grid>
                    <Grid item xs={12} md={12}>
                                <Autocomplete
                                    value={typeof props.FormProps.FormValues.custom_recipient !== 'undefined' ? props.FormProps.FormValues.custom_recipient : []}
                                    onChange={props.FormProps.HandleRecipientChange}
                                    multiple
                                    id="tags-outlined"
                                    options={(typeof props.FormProps.Custom_recipients_list !== 'undefined' && Array.isArray(props.FormProps.Custom_recipients_list)) ? props.FormProps.Custom_recipients_list : []}
                                    getOptionLabel={(option) => formatName(option.user_first_name, null, option.user_last_name)}
                                    getOptionSelected={(option, value) => option.user_id === value.user_id}
                                    filterSelectedOptions
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            label="Other Recipients"
                                            placeholder="Other Recipients"
                                            inputProps={{ ...params.inputProps, tabIndex: "13" }}
                                        />
                                    )}
                                />
                            </Grid>
                        </Grid>
             <div>
        <Alert severity="info"> This event request is to record the event and event date providing eligibility for the requested leave. This is not a time off request. Please wait for this request approval to raise related time off entries. </Alert>
        </div>
        </form>
    )
}
